/* eslint-disable prettier/prettier */
import { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
// import AuthenticationRoutes from './AuthenticationRoutes';
import Loadable from 'ui-component/Loadable';
import useAuth from 'hooks/useAuth';

// const PagesLanding = Loadable(lazy(() => import('views/pages/landing')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const { isExpired } = useAuth();
    // return useRoutes([{ path: '/', element: <PagesLanding /> }, AuthenticationRoutes, LoginRoutes, MainRoutes]);
    // disabling auth sample reoute!
    const expiredRoute = [
        { path: '/', element: <Navigate to="/dashboard" replace /> },
        { path: '/tweets', element: <Navigate to="/expired" replace /> },
        { path: '/queue', element: <Navigate to="/expired" replace /> },
        { path: '/engagement', element: <Navigate to="/expired" replace /> },
        { path: '/niche-engagement', element: <Navigate to="/expired" replace /> },
        LoginRoutes,
        MainRoutes
    ]

    const routes = [
        { path: '/', element: <Navigate to="/dashboard" replace /> },
        { path: '/', element: <Navigate to="/dashboard" replace /> },
        LoginRoutes,
        MainRoutes
    ]

    return useRoutes(isExpired ? expiredRoute : routes);
}
